import * as React from "react";
import { Experiment as Experiments } from "src/components/utility/experiment";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

const { LP_Immediate_Property_Filtering } = Experiments;

export interface ImmediateFilteringProps {
  isImmediateFilteringEnabled: boolean;
}

type Subtract<T, V> = Pick<T, Exclude<keyof T, keyof V>>;

export function withImmediatelyFilteringExperiment<P>(
  Component: React.ComponentType<ImmediateFilteringProps & Subtract<P, ImmediateFilteringProps>>
) {
  return (props: Subtract<P, ImmediateFilteringProps>) => (
    <Experiment name={LP_Immediate_Property_Filtering}>
      <ExperimentControl>
        <Component isImmediateFilteringEnabled={false} {...props} />
      </ExperimentControl>
      <ExperimentVariant bucket={1}>
        <Component isImmediateFilteringEnabled={true} {...props} />
      </ExperimentVariant>
    </Experiment>
  );
}

export default withImmediatelyFilteringExperiment;
